// Module
var code = "<tasks-list contact=$ctrl.contacts.current in-drawer=$ctrl.inDrawer></tasks-list> ";
// Exports
module.exports = code;